(function() {
  'use strict';

  let modal, form;
  let checkoutIntercepted = false;

  // Función para inicializar el modal
  function initModal() {
    console.log('🔧 [CHECKOUT MODAL] Inicializando modal...');
    modal = document.getElementById('checkout-custom-fields-modal');
    form = document.getElementById('checkout-custom-fields-form');
    
    console.log('🔍 [CHECKOUT MODAL] Elementos encontrados:', {
      modal: !!modal,
      form: !!form
    });
    
    if (!modal || !form) {
      console.error('❌ [CHECKOUT MODAL] Modal o formulario no encontrado');
      return false;
    }

    const closeButton = modal.querySelector('.checkout-fields-modal__close');
    const cancelButton = form.querySelector('.checkout-fields-form__cancel');
    // Mostrar/ocultar campos de empresa basado en radio buttons
    const esEmpresaRadios = document.querySelectorAll('input[name="es_empresa"]');
    const empresaFields = document.getElementById('empresa-fields');
    const razonSocialInput = document.getElementById('razon_social');
    const rncInput = document.getElementById('rnc');
    
    if (esEmpresaRadios.length > 0 && empresaFields) {
      esEmpresaRadios.forEach(radio => {
        radio.addEventListener('change', function() {
          if (this.value === 'si') {
            empresaFields.style.display = 'block';
            // Hacer campos obligatorios
            if (razonSocialInput) {
              razonSocialInput.setAttribute('required', 'required');
            }
            if (rncInput) {
              rncInput.setAttribute('required', 'required');
            }
          } else {
            empresaFields.style.display = 'none';
            // Quitar obligatoriedad
            if (razonSocialInput) {
              razonSocialInput.removeAttribute('required');
              razonSocialInput.value = '';
            }
            if (rncInput) {
              rncInput.removeAttribute('required');
              rncInput.value = '';
            }
          }
        });
      });
      
      // Estado inicial - si "No" está seleccionado por defecto, ocultar campos
      const esEmpresaNo = document.getElementById('es_empresa_no');
      if (esEmpresaNo && esEmpresaNo.checked) {
        empresaFields.style.display = 'none';
      }
    }
    
    // Agregar clase activa a los radio buttons de "es_empresa" cuando se seleccionan
    esEmpresaRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        // Remover clase activa de todos los labels de es_empresa
        document.querySelectorAll('input[name="es_empresa"]').forEach(r => {
          const label = r.closest('.checkout-fields-form__radio-label');
          if (label) {
            label.classList.remove('is-active');
          }
        });
        // Agregar clase activa al label del radio seleccionado
        if (this.checked && this.closest('.checkout-fields-form__radio-label')) {
          this.closest('.checkout-fields-form__radio-label').classList.add('is-active');
        }
      });
    });

    // Cerrar modal
    function closeModal() {
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    if (cancelButton) {
      cancelButton.addEventListener('click', closeModal);
    }

    // Cerrar al hacer clic fuera del modal
    const overlay = modal.querySelector('.checkout-fields-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    // Contador de caracteres para el mensaje de tarjeta
    const mensajeTarjetaTextarea = document.getElementById('mensaje_tarjeta');
    const charCountElement = document.getElementById('char-count');
    if (mensajeTarjetaTextarea && charCountElement) {
      function updateCharCount() {
        const length = mensajeTarjetaTextarea.value.length;
        const maxLength = mensajeTarjetaTextarea.maxLength || 500;
        charCountElement.textContent = `${length} / ${maxLength}`;
        
        if (length > maxLength * 0.9) {
          charCountElement.style.color = '#d32f2f';
        } else {
          charCountElement.style.color = '#999';
        }
      }
      
      mensajeTarjetaTextarea.addEventListener('input', updateCharCount);
      updateCharCount(); // Inicializar contador
    }

    // Agregar clase activa a los radio buttons cuando se seleccionan (para compatibilidad con navegadores que no soportan :has())
    const radioButtons = document.querySelectorAll('input[name="desea_aroma"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', function() {
        // Remover clase activa de todos los labels
        document.querySelectorAll('.checkout-fields-form__radio-label').forEach(label => {
          label.classList.remove('is-active');
        });
        // Agregar clase activa al label del radio seleccionado
        if (this.checked && this.closest('.checkout-fields-form__radio-label')) {
          this.closest('.checkout-fields-form__radio-label').classList.add('is-active');
        }
      });
    });

    // Validar y enviar formulario
    // Verificar que no se haya agregado el listener antes
    if (form.hasAttribute('data-submit-listener')) {
      return true; // Ya tiene el listener
    }
    form.setAttribute('data-submit-listener', 'true');
    
    // Función para manejar el submit
    const handleFormSubmit = async function(e) {
      console.log('🔵 [CHECKOUT MODAL] handleFormSubmit llamado', e);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Validar campos requeridos
      const telefono = document.getElementById('telefono')?.value?.trim();
      const deseaAroma = document.querySelector('input[name="desea_aroma"]:checked')?.value;
      const esEmpresa = document.querySelector('input[name="es_empresa"]:checked')?.value;
      const razonSocial = document.getElementById('razon_social')?.value?.trim();
      const rnc = document.getElementById('rnc')?.value?.trim();
      
      console.log('📋 [CHECKOUT MODAL] Validando campos:', {
        telefono,
        deseaAroma,
        esEmpresa,
        razonSocial,
        rnc
      });

      if (!telefono || !deseaAroma || !esEmpresa) {
        console.error('❌ [CHECKOUT MODAL] Campos requeridos faltantes');
        form.removeAttribute('data-submitting');
        alert('Por favor completa todos los campos requeridos (*)');
        return;
      }
      
      // Si es empresa, validar que Razón Social y RNC estén completos
      if (esEmpresa === 'si') {
        if (!razonSocial || !rnc) {
          console.error('❌ [CHECKOUT MODAL] Campos de empresa faltantes');
          form.removeAttribute('data-submitting');
          alert('Si es empresa, por favor completa la Razón Social y el RNC');
          return;
        }
      }
      
      // Validar formato de teléfono básico
      const telefonoRegex = /^[\d\s\-\+\(\)]+$/;
      if (!telefonoRegex.test(telefono) || telefono.length < 8) {
        console.error('❌ [CHECKOUT MODAL] Teléfono inválido');
        form.removeAttribute('data-submitting');
        alert('Por favor ingresa un número de teléfono válido');
        return;
      }
      
      console.log('✅ [CHECKOUT MODAL] Campos validados correctamente');

      // Validar mensaje (máx 5 líneas)
      const mensajeTarjeta = document.getElementById('mensaje_tarjeta')?.value || '';
      const lineCount = mensajeTarjeta.split('\n').length;
      if (lineCount > 5) {
        console.error('❌ [CHECKOUT MODAL] Mensaje tiene más de 5 líneas:', lineCount);
        form.removeAttribute('data-submitting');
        alert('El mensaje de la tarjeta dedicatoria no puede tener más de 5 líneas');
        return;
      }

      // Deshabilitar botón de envío
      const submitButton = form.querySelector('.checkout-fields-form__submit');
      const submitButtonSpan = submitButton?.querySelector('span');
      const originalText = submitButtonSpan?.textContent || submitButton?.textContent || 'Continuar al Checkout';
      
      console.log('🔘 [CHECKOUT MODAL] Estado del botón:', {
        submitButton: !!submitButton,
        submitButtonSpan: !!submitButtonSpan,
        originalText
      });
      
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.style.opacity = '0.6';
        submitButton.style.cursor = 'not-allowed';
        if (submitButtonSpan) {
          submitButtonSpan.textContent = 'Guardando...';
        } else {
          submitButton.textContent = 'Guardando...';
        }
        console.log('⏸️ [CHECKOUT MODAL] Botón deshabilitado');
      } else {
        console.error('❌ [CHECKOUT MODAL] No se encontró el botón de submit');
      }

      try {
        // Recopilar todos los datos
        const comoSupiste = document.getElementById('como_supiste')?.value || '';
        const formData = {
          attributes: {
            telefono: telefono,
            es_empresa: esEmpresa === 'si' ? 'true' : 'false',
            como_supiste: comoSupiste,
            desea_aroma: deseaAroma,
            motivo_tarjeta: document.getElementById('motivo_tarjeta')?.value || '',
            mensaje_tarjeta: mensajeTarjeta,
            razon_social: esEmpresa === 'si' ? razonSocial : '',
            rnc: esEmpresa === 'si' ? rnc : ''
          }
        };

        console.log('📤 [CHECKOUT MODAL] Enviando datos al carrito:', formData);
        
        // Actualizar atributos del carrito
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        console.log('📥 [CHECKOUT MODAL] Respuesta del carrito:', {
          ok: response.ok,
          status: response.status,
          statusText: response.statusText
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          console.error('❌ [CHECKOUT MODAL] Error al actualizar carrito:', errorData);
          throw new Error(errorData.description || 'Error al guardar los datos');
        }

        const result = await response.json().catch(() => ({}));
        console.log('✅ [CHECKOUT MODAL] Carrito actualizado correctamente:', result);
        
        // Marcar que ya pasamos por el modal ANTES de cerrar
        sessionStorage.setItem('checkout-fields-completed', 'true');
        
        console.log('🚪 [CHECKOUT MODAL] Cerrando modal y redirigiendo...');
        
        // Cerrar modal
        closeModal();
        
        // Pequeño delay para asegurar que el modal se cierre y los datos se guarden
        setTimeout(() => {
          console.log('🔀 [CHECKOUT MODAL] Redirigiendo a /checkout');
          // Proceder al checkout
          window.location.href = '/checkout';
        }, 300);

      } catch (error) {
        console.error('❌ [CHECKOUT MODAL] Error completo:', error);
        console.error('❌ [CHECKOUT MODAL] Stack:', error.stack);
        form.removeAttribute('data-submitting');
        alert('Hubo un error al guardar la información: ' + error.message + '. Por favor intenta de nuevo.');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.style.opacity = '1';
          submitButton.style.cursor = 'pointer';
          if (submitButtonSpan) {
            submitButtonSpan.textContent = originalText;
          } else if (submitButton) {
            submitButton.textContent = originalText;
          }
        }
      }
    };
    
    // Agregar listener al formulario
    console.log('📝 [CHECKOUT MODAL] Agregando listener al formulario');
    form.addEventListener('submit', handleFormSubmit);
    
    // También agregar listener directo al botón como respaldo
    const submitButton = form.querySelector('.checkout-fields-form__submit');
    console.log('🔘 [CHECKOUT MODAL] Botón encontrado:', submitButton);
    
    if (submitButton) {
      submitButton.addEventListener('click', function(e) {
        console.log('🖱️ [CHECKOUT MODAL] Click en botón detectado', {
          isSubmitting: form.hasAttribute('data-submitting'),
          button: this
        });
        
        e.preventDefault();
        e.stopPropagation();
        
        // Si el formulario no se está enviando, forzar el submit
        if (!form.hasAttribute('data-submitting')) {
          console.log('🚀 [CHECKOUT MODAL] Forzando submit desde botón');
          // Crear y disparar evento de submit
          const submitEvent = new Event('submit', { 
            bubbles: true, 
            cancelable: true 
          });
          form.dispatchEvent(submitEvent);
        } else {
          console.log('⏸️ [CHECKOUT MODAL] Submit ya en proceso, ignorando click');
        }
      }, true); // Usar capture phase para asegurar que se ejecute primero
    } else {
      console.error('❌ [CHECKOUT MODAL] No se encontró el botón de submit');
    }

    return true;
  }

  // Función para mostrar el modal
  function showModal(e) {
    console.log('👁️ [CHECKOUT MODAL] showModal llamado', e);
    
    // Si ya completamos el formulario en esta sesión, no mostrar de nuevo
    if (sessionStorage.getItem('checkout-fields-completed') === 'true') {
      console.log('⏭️ [CHECKOUT MODAL] Ya completado en esta sesión, saltando');
      sessionStorage.removeItem('checkout-fields-completed');
      return false;
    }

    if (!modal) {
      console.log('🔄 [CHECKOUT MODAL] Modal no inicializado, inicializando...');
      if (!initModal()) {
        // Si no hay modal, proceder normalmente
        console.error('❌ [CHECKOUT MODAL] No se pudo inicializar el modal');
        return false;
      }
    }

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    console.log('✅ [CHECKOUT MODAL] Mostrando modal');
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    // Cargar subtotal y mostrar resumen si hay una zona seleccionada
    setTimeout(() => {
      const zonaEnvioSelect = document.getElementById('zona_envio');
      if (zonaEnvioSelect && zonaEnvioSelect.value) {
        const selectedOption = zonaEnvioSelect.options[zonaEnvioSelect.selectedIndex];
        const precio = selectedOption.getAttribute('data-precio');
        if (precio) {
          getCartSubtotal().then(() => {
            updateSummary(precio);
          });
        }
      }
    }, 100);
    
    return true;
  }

  // Función para interceptar todos los botones de checkout
  function interceptCheckoutButtons() {
    if (checkoutIntercepted) return;
    checkoutIntercepted = true;

    // Interceptar clics en botones de checkout usando event delegation
    document.addEventListener('click', function(e) {
      const target = e.target;
      const button = target.closest('button, a, [role="button"], input[type="submit"]');
      
      if (!button) return;

      // Verificar si es un botón de checkout
      const buttonText = (button.textContent || button.value || '').trim().toLowerCase();
      const buttonClass = button.className || '';
      const buttonId = button.id || '';
      const buttonName = button.name || '';
      
      // EXCLUIR botones que NO son checkout
      const isExcludedButton = 
        buttonClass.includes('cart__icon') ||
        buttonClass.includes('cart-icon') ||
        buttonClass.includes('cart-count') ||
        buttonId.includes('cart-icon') ||
        buttonId.includes('CartIcon') ||
        buttonId.includes('cart-drawer-toggle') ||
        button.closest('.cart-icon-bubble') !== null ||
        button.closest('.cart-drawer__header') !== null ||
        button.closest('[data-cart-toggle]') !== null ||
        button.closest('#checkout-custom-fields-modal') !== null || // EXCLUIR botones dentro del modal
        button.closest('.checkout-fields-modal') !== null || // EXCLUIR botones dentro del modal
        buttonClass.includes('checkout-fields-form__submit') || // EXCLUIR botón del modal
        buttonClass.includes('checkout-fields-form__cancel') || // EXCLUIR botón cancelar del modal
        buttonText.includes('agregar al carrito') ||
        buttonText.includes('add to cart') ||
        buttonName === 'add' ||
        (buttonText.includes('carrito') && !buttonText.includes('checkout') && !buttonText.includes('pagar'));

      if (isExcludedButton) {
        console.log('⏭️ [INTERCEPT] Botón excluido de interceptación:', button);
        return; // No interceptar estos botones
      }

      // EXCLUIR botones dentro del modal (debe estar antes de verificar isCheckoutButton)
      if (button.closest('#checkout-custom-fields-modal') !== null || 
          button.closest('.checkout-fields-modal') !== null ||
          buttonClass.includes('checkout-fields-form__submit') ||
          buttonClass.includes('checkout-fields-form__cancel')) {
        console.log('⏭️ [INTERCEPT] Botón del modal excluido:', button);
        return; // No interceptar botones dentro del modal
      }

      // SOLO interceptar botones de checkout (que NO estén en el modal)
      const isCheckoutButton = 
        buttonName === 'checkout' ||
        buttonId === 'checkout' ||
        buttonId === 'CartDrawer-Checkout' ||
        (buttonId.includes('checkout') && !buttonId.includes('cart')) ||
        buttonClass.includes('cart__checkout-button') ||
        (buttonClass.includes('checkout-button') && !buttonClass.includes('checkout-fields-form')) ||
        buttonClass.includes('shopify-payment-button__button') ||
        (buttonText.includes('pagar') && !button.closest('#checkout-custom-fields-modal')) ||
        (buttonText.includes('checkout') && !button.closest('#checkout-custom-fields-modal') && !buttonText.includes('Continuar al')) ||
        buttonText.includes('comprar ahora') ||
        buttonText.includes('buy now') ||
        button.getAttribute('data-checkout') !== null ||
        button.getAttribute('data-shopify-button') !== null ||
        (button.href && button.href.includes('/checkout')) ||
        button.closest('.shopify-payment-button') !== null ||
        (button.closest('form[action*="checkout"]') !== null && button.closest('#checkout-custom-fields-modal') === null);

      if (isCheckoutButton) {
        console.log('🎯 [INTERCEPT] Botón de checkout detectado:', button);
        // Verificar que el carrito no esté vacío o que sea un botón de comprar ahora
        const cartCount = document.querySelector('[data-cart-count]')?.textContent || 
                         document.querySelector('.cart-count-bubble')?.textContent ||
                         document.querySelector('.cart-count')?.textContent ||
                         '0';
        
        const hasCartItems = parseInt(cartCount) > 0 || 
                            document.querySelector('.cart-item') ||
                            document.querySelector('[data-cart-item]') ||
                            buttonText.includes('comprar ahora') ||
                            buttonText.includes('buy now');
        
        if (hasCartItems) {
          if (showModal(e)) {
            return false;
          }
        }
      }
    }, true); // Usar capture phase para interceptar antes

    // Interceptar dynamic checkout buttons (Shopify Pay, Apple Pay, etc.)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Buscar botones de dynamic checkout
            const dynamicButtons = node.querySelectorAll?.('.shopify-payment-button__button, [data-shopify-button], iframe[src*="checkout"], .shopify-payment-button, .shopify-payment-button__button--unbranded');
            if (dynamicButtons && dynamicButtons.length > 0) {
              dynamicButtons.forEach(function(btn) {
                // Interceptar clics en iframes de dynamic checkout
                if (btn.tagName === 'IFRAME') {
                  try {
                    btn.contentWindow?.addEventListener('click', function(e) {
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                      if (showModal(e)) {
                        return;
                      }
                    }, true);
                  } catch (e) {
                    // Cross-origin, interceptar el iframe directamente
                    btn.addEventListener('load', function() {
                      try {
                        const iframeDoc = btn.contentDocument || btn.contentWindow.document;
                        iframeDoc.addEventListener('click', function(e) {
                          e.preventDefault();
                          e.stopPropagation();
                          if (showModal(e)) {
                            return;
                          }
                        }, true);
                      } catch (err) {
                        // No se puede acceder al iframe, usar otra estrategia
                      }
                    });
                  }
                } else {
                  // Interceptar clics en botones de pago dinámico
                  btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    
                    // Obtener el formulario de producto asociado
                    const productForm = btn.closest('form') || btn.closest('.product-form')?.querySelector('form');
                    if (productForm) {
                      // Agregar producto al carrito primero
                      const formData = new FormData(productForm);
                      fetch('/cart/add.js', {
                        method: 'POST',
                        body: formData
                      })
                      .then(response => {
                        if (!response.ok) {
                          throw new Error('Error al agregar al carrito');
                        }
                        return response.json();
                      })
                      .then(data => {
                        // Actualizar el carrito
                        return fetch('/cart.js')
                          .then(response => response.json())
                          .then(cart => {
                            setTimeout(() => {
                              if (showModal(e)) {
                                return;
                              }
                            }, 300);
                          });
                      })
                      .catch(error => {
                        console.error('Error:', error);
                        alert('Error al agregar el producto al carrito. Por favor intenta de nuevo.');
                      });
                    } else {
                      // Si no hay formulario, solo mostrar modal
                      if (showModal(e)) {
                        return;
                      }
                    }
                    
                    return false;
                  }, true);
                }
              });
            }
            
            // Si el nodo mismo es un botón de checkout
            if (node.matches && (
              node.matches('button[name="checkout"]') ||
              node.matches('.shopify-payment-button__button') ||
              node.matches('[data-shopify-button]') ||
              node.matches('.shopify-payment-button')
            )) {
              node.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                if (showModal(e)) {
                  return;
                }
              }, true);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // También interceptar botones dinámicos que ya existen
    setTimeout(function() {
      const existingButtons = document.querySelectorAll('.shopify-payment-button__button, [data-shopify-button], .shopify-payment-button');
      existingButtons.forEach(function(btn) {
        if (!btn.hasAttribute('data-checkout-intercepted')) {
          btn.setAttribute('data-checkout-intercepted', 'true');
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            const productForm = btn.closest('form') || btn.closest('.product-form')?.querySelector('form');
            if (productForm) {
              const formData = new FormData(productForm);
              fetch('/cart/add.js', {
                method: 'POST',
                body: formData
              })
              .then(response => response.json())
              .then(data => {
                return fetch('/cart.js')
                  .then(response => response.json())
                  .then(cart => {
                    setTimeout(() => {
                      if (showModal(e)) {
                        return;
                      }
                    }, 300);
                  });
              })
              .catch(error => {
                console.error('Error:', error);
                alert('Error al agregar el producto al carrito.');
              });
            } else {
              if (showModal(e)) {
                return;
              }
            }
            return false;
          }, true);
        }
      });
    }, 500);

    // Interceptar enlaces directos a checkout
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      if (link && link.href && link.href.includes('/checkout')) {
        if (showModal(e)) {
          return;
        }
      }
    }, true);

    // Interceptar envíos de formularios que van a checkout o cart
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form) return;
      
      // Si es el formulario del modal, no interceptar
      if (form.id === 'checkout-custom-fields-form') {
        return;
      }
      
      const formAction = form.action || '';
      const formId = form.id || '';
      const formClass = form.className || '';
      
      // EXCLUIR formularios de agregar al carrito
      const isAddToCartForm = 
        formAction.includes('/cart/add') ||
        (formAction.includes('/cart') && !form.querySelector('button[name="checkout"]') && !form.querySelector('input[name="checkout"]')) ||
        formId.includes('product-form') ||
        formClass.includes('product-form');
      
      if (isAddToCartForm) {
        return; // No interceptar formularios de agregar al carrito
      }
      
      // Verificar si es un formulario que lleva al checkout
      const isCheckoutForm = 
        formAction.includes('/checkout') ||
        form.querySelector('button[name="checkout"]') ||
        form.querySelector('input[name="checkout"]') ||
        form.querySelector('.shopify-payment-button') ||
        form.querySelector('[data-shopify-button]');
      
      if (isCheckoutForm) {
        // Verificar si el formulario tiene un botón de checkout
        const checkoutButton = form.querySelector('button[name="checkout"], input[name="checkout"]');
        if (checkoutButton && !checkoutButton.hasAttribute('data-checkout-skipped')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (showModal(e)) {
            return false;
          }
        }
      }
    }, true);
    
    // Interceptar botones de "Comprar ahora" en formularios de producto
    document.addEventListener('click', function(e) {
      const target = e.target;
      const form = target.closest('form[action*="/cart"], form.product-form, form[data-product-form], form[action="/cart/add"]');
      
      if (!form) return;
      
      // Verificar si es un botón de "Comprar ahora" o "Buy Now" (NO "agregar al carrito")
      const button = target.closest('button, input[type="submit"]');
      if (!button) return;
      
      const buttonText = (button.textContent || button.value || '').trim().toLowerCase();
      const buttonClass = button.className || '';
      
      // EXCLUIR botones de "agregar al carrito"
      const isAddToCartButton = 
        buttonText.includes('agregar al carrito') ||
        buttonText.includes('add to cart') ||
        buttonClass.includes('product-form__cart-submit') ||
        buttonClass.includes('add-to-cart') ||
        (buttonName === 'add' && !buttonText.includes('comprar ahora') && !buttonText.includes('buy now'));
      
      if (isAddToCartButton) {
        return; // No interceptar botones de agregar al carrito
      }
      
      const isBuyNowButton = 
        buttonText.includes('comprar ahora') ||
        buttonText.includes('buy now') ||
        buttonClass.includes('buy-now') ||
        button.getAttribute('data-buy-now') !== null ||
        (form.querySelector('.shopify-payment-button') && button.closest('.shopify-payment-button'));
      
      if (isBuyNowButton) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Deshabilitar el botón mientras se procesa
        button.disabled = true;
        const originalButtonText = button.textContent || button.value;
        if (button.textContent) button.textContent = 'Agregando...';
        if (button.value) button.value = 'Agregando...';
        
        // Agregar producto al carrito primero
        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error al agregar al carrito');
          }
          return response.json();
        })
        .then(data => {
          // Actualizar el carrito para asegurar que esté sincronizado
          return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              // Después de actualizar, mostrar el modal
              setTimeout(() => {
                if (showModal(e)) {
                  return;
                }
              }, 300);
            });
        })
        .catch(error => {
          console.error('Error al agregar al carrito:', error);
          alert('Error al agregar el producto al carrito. Por favor intenta de nuevo.');
          // Restaurar el botón
          button.disabled = false;
          if (button.textContent) button.textContent = originalButtonText;
          if (button.value) button.value = originalButtonText;
        });
        
        return false;
      }
    }, true);
  }

  // Inicializar cuando el DOM esté listo
  console.log('🚀 [CHECKOUT MODAL] Script cargado, estado del documento:', document.readyState);
  
  if (document.readyState === 'loading') {
    console.log('⏳ [CHECKOUT MODAL] Esperando DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', function() {
      console.log('📄 [CHECKOUT MODAL] DOMContentLoaded disparado');
      initModal();
      interceptCheckoutButtons();
    });
  } else {
    console.log('⚡ [CHECKOUT MODAL] Documento ya listo, inicializando inmediatamente');
    initModal();
    interceptCheckoutButtons();
  }

    // También interceptar después de que se carguen los scripts dinámicos
    setTimeout(function() {
      interceptCheckoutButtons();
    }, 1000);

    // Interceptar history.pushState y replaceState para redirecciones a checkout
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    
    history.pushState = function() {
      if (arguments[2] && typeof arguments[2] === 'string' && arguments[2].includes('/checkout')) {
        if (sessionStorage.getItem('checkout-fields-completed') !== 'true') {
          if (showModal()) {
            return;
          }
        }
      }
      return originalPushState.apply(history, arguments);
    };
    
    history.replaceState = function() {
      if (arguments[2] && typeof arguments[2] === 'string' && arguments[2].includes('/checkout')) {
        if (sessionStorage.getItem('checkout-fields-completed') !== 'true') {
          if (showModal()) {
            return;
          }
        }
      }
      return originalReplaceState.apply(history, arguments);
    };
})();

